import storage from 'store'
import {  ACCESS_TOKEN} from '@/store/mutation-types'

const testdata = {
  namespaced:true,
  state: {
    token: '',
    name: '',
    avatar: '',
    roles: [],
    info: {},
    superAdmin: false,
    permissions: [],
    noPermissions: false,
	
	menuList:[],
	userInfor:[],
	msgList:[],
	resData:[{
		id:1,
		title: '水利水位表（8日21时00分）',
		ftitle:"8月21日 00时 发布",
		type:"pdf",
		cat:"水利水位表",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC82LnBkZg%3D%3D",
		read:true
	},],
  },

  mutations: {
	//直接修改 state中的数据  //所有状态变更通过 mutation 完成。
	SetResData:function(state,item){
		state.resData=item;
	},
	  
  },

  actions: {
    // 通过提交 mutation 间接修改
	resDataAction:function({commit})
	{
		commit("SetResData",[
	{
		id:1,
		title: '水利水位表（8日21时00分）',
		ftitle:"8月21日 00时 发布",
		type:"pdf",
		cat:"水利水位表",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC82LnBkZg%3D%3D",
		read:true
	},
	{
		 id:2,
		title: '台风“丹娜丝”避灾安置场所使用情况、转移',
		ftitle:"8月21日 00时 发布",
		cat:"避灾安置场所使用情况...",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC80LmRvY3g%3D",
		type:"xml"
	},
	{
		id:3,
		title: '平阳第4号台风“丹娜丝”防御工作动态...',
		ftitle:"7月8日 20时 发布",
		cat:"工作动态",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC8yLnhsc3g%3D",
		type:"word"
	},
	{
		  id:4,
		title: '14时 平阳县人员转移情况统计表-细分(2)',
		ftitle:"8月21日 14时 发布",
		cat:"人员转移统计表",
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC8zLnhscw%3D%3D",
		type:"xml",
		read:true
	},
	{
		  id:5,
		title: '气象累计雨量图',
		ftitle:"8月21日 14时 发布",	
		cat:"气象累计雨量图",
		type:"pdf",
		read:false,
		src:"https://kkfile.xiaoqibao.net/preview/onlinePreview?aHR0cHM6Ly9odG1sLnhpYW9xaWJhby5uZXQvY2xqL3lqanBhZC81LnBuZw%3D%3D"
	},
	{
		  id:6,
		title: 'Title 6',
		type:"dir"
	},
	{
		  id:7,
	  title: 'Title 7',
		type:"list"
	},
	{
		  id:8,
	  title: 'Title 8',
		type:"dir"
	},
	{
		  id:9,
	  title: 'Title 9',
		type:"dir"
	},
	{
		  id:10,
	  title: 'Title 10',
		type:"dir"
	},
	{
		  id:11,
	  title: 'Title 11',
		type:"dir"
	},
	{
		  id:12,
	  title: 'Title 12',
		ftitle:"8月21日 14时 发布",
		type:"pdf"
	},
	{
		  id:13,
	  title: 'Title 13',
		type:"dir"
	}]);
	},
	
	
	//跨模块访问 State
	fetchData({ rootState }) {
	    const userModuleData = rootState.user.name;
	},
	
	
	
  }
}

export default testdata